export default __webpack_public_path__ + "static/media/v2.f135d84c.svg";